module.exports = __webpack_public_path__ + "img/aland-islands.57efa792.svg";